import React from 'react';
import { Button, Dropdown } from '@bynder/design-system';
import { IconDelete, IconEdit, IconMore } from '@bynder/icons';
import { useTranslate } from '@bynder/localization';
import { ButtonWrapper } from './styled';

interface Props {
    onEdit: () => void;
    onDelete: () => void;
}

const CollectionMenu = ({ onEdit, onDelete }: Props) => {
    const { translate } = useTranslate();

    return (
        <Dropdown
            trigger={({ isOpen, ...triggerProps }) => (
                <ButtonWrapper $isVisible={isOpen}>
                    <Button
                        variant="clean"
                        aria-label={translate('components.overview.collections.menu')}
                        isPressed={isOpen}
                        {...triggerProps}
                    >
                        <IconMore />
                    </Button>
                </ButtonWrapper>
            )}
        >
            <Dropdown.Item
                onClick={() => {
                    onEdit();
                }}
                icon={<IconEdit />}
            >
                {translate('components.overview.collections.menu.editDetails')}
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item
                onClick={() => {
                    onDelete();
                }}
                icon={<IconDelete />}
            >
                {translate('components.overview.collections.menu.delete')}
            </Dropdown.Item>
        </Dropdown>
    );
};

export default CollectionMenu;
